
define('text!libs/strand/test/imports/test-strand-template-finder.html',[],function () { return '<template id="import">\n\t<div>passed as import <span>{{field}}</span></div>\n</template>\n';});

